import { render, staticRenderFns } from "./GroupAdminMenu.vue?vue&type=template&id=d3e66d42&"
import script from "./GroupAdminMenu.vue?vue&type=script&lang=js&"
export * from "./GroupAdminMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports